import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconBuildingCommunity } from '@tabler/icons-react';
import { COMPONENT_PROJECT_SELECT_OPTIONS } from '../dashboard/admin/AdminComponentProjectMetrics';
import { useAdminComponentProjectFilterStore } from '../../stores/adminComponentProjectFilterStore';
import { NavbarCompactSelect } from '../layout/NavbarCompactSelect';

const ADMIN_DASHBOARD_PATH = '/admin/dashboard';

function staysOnCurrentAdminPage(pathname: string): boolean {
  return pathname === ADMIN_DASHBOARD_PATH;
}

export function NavbarComponentProjectSelector() {
  const componentProject = useAdminComponentProjectFilterStore((s) => s.componentProject);
  const setComponentProjectStore = useAdminComponentProjectFilterStore(
    (s) => s.setComponentProject
  );
  const navigate = useNavigate();
  const location = useLocation();

  const setComponentProject = useCallback(
    (value: string | null) => {
      setComponentProjectStore(value);
      if (!staysOnCurrentAdminPage(location.pathname)) {
        navigate(ADMIN_DASHBOARD_PATH, { replace: true });
      }
    },
    [location.pathname, navigate, setComponentProjectStore]
  );

  return (
    <NavbarCompactSelect
      icon={<IconBuildingCommunity size={16} aria-hidden />}
      ariaLabel="Component project"
      placeholder="Entire consortium"
      data={COMPONENT_PROJECT_SELECT_OPTIONS}
      value={componentProject}
      onChange={setComponentProject}
      clearable
      width="min(165px, 36vw)"
    />
  );
}
